import React, { Fragment } from 'react';
import { PlayMenu } from './PlayMenu';
import { useMenuEntries } from './use-menu-entries';
import SvgProfile from '../../../../../play-core/icons/Profile';
import { useHeaderColorSet } from '../MainNavigation/MainNavigation.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderMenu = () => {
  const {
    menuEntries,
    loggedInMenuEntries
  } = useMenuEntries();
  const colorSet = useHeaderColorSet();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(PlayMenu, {
      menuEntries: loggedInMenuEntries,
      icon: /*#__PURE__*/_jsx(SvgProfile, {}),
      iconSize: 30,
      colorSet: colorSet
    }), /*#__PURE__*/_jsx(PlayMenu, {
      colorSet: colorSet,
      menuEntries: menuEntries
    })]
  });
};